/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Umumiy xarita — barcha dala poligonlari bitta sun'iy yo'ldosh xaritasida.
 * Rang — kategoriya rangi. Poligon bosilganda dala sahifasiga o'tadi. */
import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Layout from '../../components/Layout'
import Loader from '../../components/common/Loader'
import { farmRequest } from './api'
import { loadLeaflet, SATELLITE_URL } from './leafletLoader'

export default function FarmMapAll() {
    const containerRef = useRef(null)
    const history = useHistory()
    const [state, setState] = useState('loading') // loading | ready | empty | failed

    useEffect(() => {
        let map = null
        let cancelled = false

        async function init() {
            try {
                const [L, geojson] = await Promise.all([
                    loadLeaflet(),
                    farmRequest({ url: 'fields/geojson/' }),
                ])
                if (cancelled || !containerRef.current) return
                const features = geojson.features || []
                if (features.length === 0) {
                    setState('empty')
                    return
                }
                map = L.map(containerRef.current, { attributionControl: false })
                L.tileLayer(SATELLITE_URL, { maxZoom: 19 }).addTo(map)

                const group = L.featureGroup()
                features.forEach((f) => {
                    const ring = (f.geometry.coordinates && f.geometry.coordinates[0]) || []
                    const latlngs = ring.map(([lng, lat]) => [lat, lng])
                    if (latlngs.length < 3) return
                    const color = f.properties.color || '#D97757'
                    const polygon = L.polygon(latlngs, {
                        color, weight: 2.5, fillOpacity: 0.35,
                    }).addTo(group)
                    polygon.bindTooltip(
                        `<b>${f.properties.name}</b><br/>${f.properties.category} · ${f.properties.areaHa} ga`,
                        { sticky: true },
                    )
                    polygon.on('click', () => history.push(`/farm/fields/${f.properties.id}`))
                })
                group.addTo(map)
                map.fitBounds(group.getBounds(), { padding: [24, 24] })
                setState('ready')
            } catch (e) {
                if (!cancelled) setState('failed')
            }
        }
        init()
        return () => { cancelled = true; if (map) map.remove() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Layout>
            <nav className="breadcrumb mb-3" aria-label="breadcrumbs">
                <ul>
                    <li><Link to="/farm">Dala boshqaruvi</Link></li>
                    <li className="is-active"><a href="#!">Xarita</a></li>
                </ul>
            </nav>
            <h1 className="title is-4">Dalalar xaritasi</h1>

            {state === 'loading' && <Loader center large />}
            {state === 'empty' && (
                <div className="box has-text-centered py-6 has-text-grey">
                    Chegarasi chizilgan dala yo‘q. Chegara mobil ilovada chiziladi.
                </div>
            )}
            {state === 'failed' && (
                <div className="box has-text-centered py-6 has-text-grey">
                    Xaritani yuklab bo‘lmadi (internet/CDN yoki ruxsat).
                </div>
            )}
            {/* Balandlik doim 70vh (leaflet o'lchamni to'g'ri olishi uchun);
                bo'sh/xato holatlarda yashiriladi */}
            <div ref={containerRef}
                style={{
                    height: state === 'empty' || state === 'failed' ? 0 : '70vh',
                    borderRadius: 8,
                    overflow: 'hidden',
                    zIndex: 0,
                }} />
        </Layout>
    )
}
